import { NextApiRequest } from 'next';

import { Vertical } from 'utils/vertical';
import { assertIsVertical } from 'utils/type-guards';

export function resolveVertical(req: NextApiRequest): Vertical {
  return assertIsVertical(req.query.vertical);
}
